import { Company, FrenchCompany } from '@modules-deprecated/app/companies/types'

import { parseLegalStatus } from '../../invoicingSettings/utils/parseLegalStatus'
import type { CompanyDetails } from '../types/CompanyDetails'
import { computeVatNumber } from './computeVatNumber'
import { isFrenchCompany } from './isFrenchCompany'

export const mapCompanyToCompanyDetails = (
  company: Partial<Company> | Partial<FrenchCompany>,
  countryCode = '',
): CompanyDetails => {
  const isFrench = isFrenchCompany(company)
  const vatNo = computeVatNumber(countryCode, isFrench ? company.siret : undefined) ?? ''

  if (isFrench) {
    const { legalStatusCustom, legalStatusOption } = parseLegalStatus(company.legalForm)

    return {
      companyAddress: company.street ?? '',
      companyCity: company.city ?? '',
      companyZipCode: company.zipcode ?? '',
      isVatExempted: false,
      legalStatusCustom,
      legalStatusOption,
      registrationNo: company.siret ?? '',
      vatNo,
      ...(!!company.siret && { isSiretPendingAssignment: false }),
    }
  }

  return {
    companyAddress: [company.street, company.number].filter(Boolean).join(' '),
    companyCity: company.city ?? '',
    companyZipCode: company.zipcode ?? '',
    // No field isVatExempted in search response
    isVatExempted: false,
    registrationNo: company.id ?? '',
    vatNo,
  }
}
